<template>
  <div class="articles-list">
    <Spinner v-if="articles.status.value === 'pending'" />
    <div v-else-if="articles.status.value === 'error'">
      {{ articles.error.value }}
    </div>
    <article
      v-else
      v-for="article in articles.data.value"
      :key="defaultItem(article.slugs).slug"
    >
      <div class="header">
        <h2>{{ article.title }}</h2>
        <div class="published-date" v-if="article.published_at">
          {{ new Date(article.published_at!).toLocaleDateString() }}
        </div>
        <div v-else class="published-date">Draft</div>
      </div>
      <div :class="{ split: !!article.header_image }">
        <Picture
          v-if="article.header_image"
          :src="article.header_image"
          :alt="`Image for ${article.title}`"
          class="header-image"
        />
        <div class="content">
          <Content :value="article.first_paragraph" partial />
          <nuxt-link
            :to="`/articles/${defaultItem(article.slugs).slug} `"
            class="read-more"
            >Read more</nuxt-link
          >
        </div>
      </div>
    </article>
  </div>
</template>
<script lang="ts" setup>
definePageMeta({ authenticated: false, layout: "marketing" });

const articles = useSupabaseInfiniteQuery({
  queryKey: () => ["articles", "summary"],
  queryFn: (S) =>
    S.from("articles").select(
      "id, title, header_image, first_paragraph, published_at, slugs!inner ( slug, default )"
    ),
  ordering: [["published_at", "desc"]],
});

function defaultItem<T extends { default: boolean | null }>(list: T[]): T {
  const def = list.find((arg) => arg.default);
  if (!def) throw new Error("Could not find default slug");
  return def;
}

onServerPrefetch(() => articles.suspense());
</script>
<style scoped>
.articles-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

article {
  border: 1px solid #ccc;
  max-width: var(--column-width);
  padding: 1rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: var(--half-grid);
}

.split {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: var(--grid);
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--grid);
}

.content > * {
  width: 100%;
}

:deep(.tiptap) {
  place-items: stretch;
}

.header {
  display: flex;
  justify-content: space-between;
}

.header-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 4px;
}

.published-date {
  font-style: italic;
  color: #555;
}

.read-more {
  display: inline-block;
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 4px;
}

.read-more:hover {
  background-color: #0056b3;
}
</style>
